import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../services/api';

export const useDeleteGalleryPhoto = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (photoUrl: string) => {
      await api.delete('/sitters/gallery', { data: { photoUrl } });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sitterProfile'] });
    },
  });
};
